import React from 'react';
import { Navigate, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Articles from './pages/Articles';
import Article from './pages/Article';
import './styles/global.css';

function App() {
 return (
  <AuthProvider>
   <Router>
    <Routes>
     <Route path="/" element={<Home />} />
     <Route path="/shop" element={<Shop />} />
     <Route path="/articles" element={<Articles />} />
     <Route path="/article/:slug" element={<Article />} />
     <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
   </Router>
  </AuthProvider>
 );
}

export default App;
